import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-20 pb-16 md:pt-32 md:pb-24 px-4 relative overflow-hidden" data-id="element-55">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#14B8A6] opacity-10 blur-[120px] rounded-full pointer-events-none" data-id="element-56" />

      <div className="max-w-4xl mx-auto text-center relative z-10 animate-fade-in-up" data-id="element-57">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1A2F4A] border border-[#2DD4BF]/30 text-[#2DD4BF] text-sm font-medium mb-8" data-id="element-58">
          <ShieldCheckIcon className="w-4 h-4" data-id="element-59" />
          <span data-id="element-60">ADHD Executive Function Toolkit</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#F1F5F9] leading-tight mb-6 text-balance" data-id="element-61">
          The ADHD Executive Function Toolkit
        </h1>

        <p className="text-xl md:text-2xl text-[#2DD4BF] font-medium max-w-3xl mx-auto mb-12 text-balance" data-id="element-62">
          The "Dopamine-Menu" System to Stop the 5 PM Panic and Reclaim Your
          Professional Edge
        </p>

        <div className="relative max-w-2xl mx-auto mb-12 animate-float" data-id="element-63">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B1A2E] via-transparent to-transparent z-10 h-full w-full bottom-0" data-id="element-64" />
          <img src="https://cdn.magicpatterns.com/uploads/vnC9YVPmeAGn9TfmGke4ou/imageADHD2B.png" alt="The ADHD Executive Function Toolkit Digital Product Mockup" className="w-full h-auto rounded-xl shadow-2xl shadow-[#000000]/50 relative z-0" data-id="element-65" />
        </div>

        <button onClick={scrollToOffer} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-[#0B1A2E] bg-[#2DD4BF] rounded-lg overflow-hidden transition-all hover:scale-[1.02] hover:bg-[#14B8A6] hover:shadow-[0_0_20px_rgba(45,212,191,0.4)] focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:ring-offset-2 focus:ring-offset-[#0B1A2E]" data-id="element-66">
          Download the Toolkit — $29
        </button>
      </div>
    </section>;
}